import $ from 'jquery';

$( () => {
  const showAll = document.querySelector( '#show-all' )
  const showInterior = document.querySelector( '#show-all-interior' )
  const showExterior = document.querySelector( '#show-all-exterior' )

  const selectAll = document.querySelectorAll('.hidden-content')
  const selectAllInterior = document.querySelectorAll('.hidden-content-interior')
  const selectAllExterior = document.querySelectorAll('.hidden-content-exterior')

  $( showAll ).on( 'click', ( elem ) => {
    let $thisButton = $( elem.currentTarget );
    $( '.hidden-content.hide' ).length ? $('.show-hide-text').html('Show Less') : $('.show-hide-text').html('Show all')
    $( '.hidden-content.hide' ).length 
      ? $( '.hidden-content.hide' ).slice( 0, $( '.hidden-content.hide' ).length ).removeClass( 'hide' ) 
      : selectAll.forEach((element, index ) => {
          if(index >= 12) {
            element.classList.add( 'hide' )
          }
        }); 

        $( '.floor-plans-grid' ).removeClass( 'show-less' )
        $thisButton.hide();
  })
  
  $( showInterior ).on( 'click', () => {
      $( '.hidden-content-interior.hide' ).length ? $('.show-hide-text-interior').html('Show Less') : $('.show-hide-text-interior').html('Show all')
      $( '.hidden-content-interior.hide' ).length 
      ? $( '.hidden-content-interior.hide' ).slice( 0, $( '.hidden-content-interior.hide' ).length ).removeClass( 'hide' ) 
      : selectAllInterior.forEach((element, index ) => {
          if(index >= 12) {
            element.classList.add( 'hide' )
          }
        }); 
  })

  $( showExterior ).on( 'click', () => {
    $( '.hidden-content-exterior.hide' ).length ? $('.show-hide-text-exterior').html('Show Less') : $('.show-hide-text-exterior').html('Show all')
    $( '.hidden-content-exterior.hide' ).length 
      ? $( '.hidden-content-exterior.hide' ).slice( 0, $( '.hidden-content-exterior.hide' ).length ).removeClass( 'hide' ) 
      : selectAllExterior.forEach((element, index ) => {
          if(index >= 4) {
            element.classList.add( 'hide' )
          }
        }); 
  })

});
